var cov_1uqllpj9nl = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Popover/context.tsx",
      hash = "a9aaf3e9c304308e606bed1566651a51fa40faf3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Popover/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 78
        }
      },
      "1": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 7,
          column: 28
        }
      },
      "2": {
        start: {
          line: 10,
          column: 24
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "3": {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "4": {
        start: {
          line: 12,
          column: 68
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "5": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 86
        }
      },
      "6": {
        start: {
          line: 13,
          column: 26
        },
        end: {
          line: 13,
          column: 74
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 25
          },
          end: {
            line: 12,
            column: 26
          }
        },
        loc: {
          start: {
            line: 12,
            column: 68
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 68
          },
          end: {
            line: 12,
            column: 69
          }
        },
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 86
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 13
          },
          end: {
            line: 13,
            column: 14
          }
        },
        loc: {
          start: {
            line: 13,
            column: 26
          },
          end: {
            line: 13,
            column: 74
          }
        },
        line: 13
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/Popover/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_1uqllpj9nl.s[0]++, createReactContext(undefined));

var _ref = (cov_1uqllpj9nl.s[1]++, context),
    Consumer = _ref.Consumer; // eslint-disable-next-line


export var Provider = (cov_1uqllpj9nl.s[2]++, context.Provider);
cov_1uqllpj9nl.s[3]++;
export var consumer = function consumer(Origin) {
  cov_1uqllpj9nl.f[0]++;
  cov_1uqllpj9nl.s[4]++;
  return function (props) {
    cov_1uqllpj9nl.f[1]++;
    cov_1uqllpj9nl.s[5]++;
    return (
      /*#__PURE__*/
      React.createElement(Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 13,
          columnNumber: 3
        }
      }, function (bindChain) {
        cov_1uqllpj9nl.f[2]++;
        cov_1uqllpj9nl.s[6]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            bindChain: bindChain,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 13,
              columnNumber: 27
            }
          }))
        );
      })
    );
  };
};